<template>
    <td class="day-table" :class="'date-' + day.start.format('YYYY-MM-DD')">
        <div class="card card-gg">
            <div class="table-list-header clearfix">
                <div class="float-left">
                    <span class="text-uppercase mr-3">{{ this.day.start.format('MMMM D') }}</span>
                    <span class="mr-3">{{ this.day.start.format('dddd') }}</span>
                    {{ day.schedule }}
                </div>
                <template v-if="expired">
                    <div class="total-asset-value">
                        Daily Potential Yield:
                        <span class="text-success">{{ dailyYield | money }}</span>
                    </div>
                </template>
                <template v-else>
                    <popper :options="{ placement: 'right' }" trigger="click" :key="loadComponent">
                        <div class="popper">
                            <price-modifier-field :end="day.end" :modifier="priceModifier" :products="products" :start="day.start" inline-template>
                                <div class="dynamic-pricing mt-3 p-3">
                                    <h6 class="text-center text-dark font-weight-bold">
                                        Modify Asset Pricing By
                                    </h6>
                                    <t-slider v-model="form.modifier"></t-slider>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex justify-content-center mb-3 font-weight-bold">
                                            <span class="invalid-feedback" v-show="form.errors.has('modifier')">
                                                @{{ form.errors.get('modifier') }}
                                            </span>
                                            <div class="p-2 text-dark">
                                                Value of Posted Inventory:
                                            </div>
                                            <div class="p-2 text-success">
                                                {{ adjustedValue | money }}
                                            </div>
                                        </div>
                                        <form-errors :errors="form.errors" class="text-center d-block" field="start_date"></form-errors>
                                        <div class="d-flex justify-content-center mb-3">
                                            <button @click.prevent="saveModifier" class="btn btn-padding btn-secondary m-1" type="button">
                                                Save
                                            </button>
                                            <button @click.prevent="hide" class="btn btn-padding btn-cancel m-1" type="button">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </price-modifier-field>
                        </div>
                        <button class="total-asset-value" slot="reference">
                            Daily Potential Yield:
                            <span class="text-success">{{ dailyYield | money }}</span>
                        </button>
                    </popper>
                </template>

                <!--                <a href="#" class="total-asset-value">-->
                <!--                    Daily Potential Yield: <span class="text-success">{{ dailyYield | money }}</span>-->
                <!--                </a>-->
            </div>
            <table class="table table-bordered">
                <thead>
                    <th>Asset Name</th>
                    <th>Category</th>
                    <th>Online Base Price</th>
                    <th>Online Unit Price</th>
                    <th>Units Available</th>
                    <th>Units Sold</th>
                    <th>Units Posted</th>
                    <th style="width: 35px;">Action</th>
                </thead>
                <tbody>
                    <template v-for="(product, key) in products">
                        <posted-assets-list-item :key="key" :product="product" :day="day"></posted-assets-list-item>
                    </template>
                </tbody>
            </table>
        </div>
    </td>
</template>

<script>
import PriceModifierField from '../pricing/PriceModifierField';
import PostedAssetsListItem from './PostedAssetsListItem';

export default {
    props: ['day', 'priceModifier'],
    components: { PriceModifierField, PostedAssetsListItem },
    data() {
        return {
            products: null,
            dailyYield: 0,
            expired: true,
        };
    },
    created() {
        const _this = this;
        this.expired = moment().diff(this.day.start, 'days') >= 0;
        this.products = this.day.products;
        this.getYield();

        Bus.$on('listViewYieldChange', (payload) => {
            if (payload.day_id === this.day.id) {
                _this.dailyYield = _this.dailyYield + payload.change;
            }
        });
    },
    methods: {
        getYield() {
            this.dailyYield = _.sumBy(this.products, (item) => {
                return _.get(item, 'potential_yield');
            });
        },
    },
    computed: {
        rowTitle() {
            return this.day.start.format('MMMM D  dddd');
        },
    },
};
</script>
